import { render, staticRenderFns } from "./VSettings.vue?vue&type=template&id=20afea58&"
import script from "./VSettings.vue?vue&type=script&lang=js&"
export * from "./VSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports